// import React, { useState, useEffect, useRef } from 'react';
// import { Chart, registerables } from 'chart.js';
// import { useSelector } from 'react-redux';
// import api from '../../Services/api';
// import '../../Styles/Dashboard.css';

// Chart.register(...registerables);

// const SkeletonStatsCard = () => (
//   <div className="stats-card skeleton">
//     <div className="stats-content">
//       <div className="stats-info">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-value"></div>
//         <div className="skeleton-subtitle"></div>
//       </div>
//       <div className="stats-icon skeleton-icon"></div>
//     </div>
//   </div>
// );

// const SkeletonChartCard = () => (
//   <div className="chart-card skeleton">
//     <div className="chart-header">
//       <div className="skeleton-chart-title"></div>
//     </div>
//     <div className="chart-wrapper">
//       <div className="skeleton-chart"></div>
//     </div>
//   </div>
// );

// const SkeletonUserListCard = () => (
//   <div className="list-card skeleton">
//     <div className="list-header">
//       <div className="skeleton-list-title"></div>
//       <div className="skeleton-button"></div>
//     </div>
//     <div className="list-content">
//       <div className="skeleton-table">
//         {[1, 2, 3, 4, 5].map((i) => (
//           <div key={i} className="skeleton-row">
//             {[1, 2, 3, 4].map((j) => (
//               <div key={j} className="skeleton-cell"></div>
//             ))}
//           </div>
//         ))}
//       </div>
//     </div>
//     <div className="quick-stats">
//       <div className="quick-stat">
//         <div className="skeleton-stat"></div>
//       </div>
//       <div className="quick-stat">
//         <div className="skeleton-stat"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonRecentBookings = () => (
//   <div className="recent-bookings skeleton">
//     <div className="recent-header">
//       <div className="skeleton-recent-title"></div>
//       <div className="skeleton-button"></div>
//     </div>
//     <div className="bookings-table">
//       <div className="skeleton-table">
//         {[1, 2, 3, 4, 5].map((i) => (
//           <div key={i} className="skeleton-row">
//             {[1, 2, 3, 4, 5, 6].map((j) => (
//               <div key={j} className="skeleton-cell"></div>
//             ))}
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// );


// const Modal = ({ isOpen, title, data, columns, total, onClose, periodLabel }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>{title} - {periodLabel}</h3>
//           <button className="modal-close-btn" onClick={onClose}>×</button>
//         </div>
//         <div className="modal-body">
//           <div className="modal-table-container">
//             <table className="modal-table">
//               <thead>
//                 <tr>
//                   {columns.map((col, index) => (
//                     <th key={index}>{col}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.map((item, index) => (
//                   <tr key={item._id || item.id || index}>
//                     {columns.map((col, colIndex) => {
//                       let value = '';

//                       if (col === 'Status') {
//                         value = item.isActive === false ? 'Inactive' : item.status || 'Active';
//                         return (
//                           <td key={colIndex}>
//                             <span className={`status-badge ${value.toLowerCase()}`}>
//                               {value}
//                             </span>
//                           </td>
//                         );
//                       }

//                       switch (col) {
//                         case 'Name':
//                           value = item.name || 'N/A';
//                           break;
//                         case 'Email':
//                           value = item.email || 'N/A';
//                           break;
//                         case 'Phone':
//                           value = item.phone || item.mobileNumber || 'N/A';
//                           break;
//                         case 'Buses':
//                           value = item.busCount || item.buses || 0;
//                           break;
//                         case 'Bus':
//                           value = item.assignedBus?.busNumber || item.bus || 'N/A';
//                           break;
//                         case 'Experience':
//                           value = item.experience || 'N/A';
//                           break;
//                         case 'Joined':
//                           value = item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A';
//                           break;
//                         case 'License':
//                           value = item.licenseNumber || 'N/A';
//                           break;
//                         case 'PNR':
//                           value = item.pnr || 'N/A';
//                           break;
//                         case 'Passenger':
//                           value = item.user?.name || item.name || 'N/A';
//                           break;
//                         case 'Route':
//                           value = item.route ? `${item.route.from} to ${item.route.to}` : 'N/A';
//                           break;
//                         case 'Amount':
//                           value = `₹${item.amount || item.paymentAmount || 0}`;
//                           break;
//                         case 'Date':
//                           value = item.bookedOn || item.date || (item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A');
//                           break;
//                         default:
//                           value = item[col.toLowerCase()] || 'N/A';
//                       }

//                       return <td key={colIndex}>{value}</td>;
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           {data.length === 0 && (
//             <div className="no-data">
//               <p>No data available for {periodLabel}</p>
//             </div>
//           )}
//         </div>
//         <div className="modal-footer">
//           <p>Total Records: {total || data.length}</p>
//           <button className="modal-close-btn secondary" onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Home = () => {
//   const { token } = useSelector((state) => state.user);

//   const [dashboardData, setDashboardData] = useState({
//     revenue: 0,
//     totalTickets: 0,
//     bookedTickets: 0,
//     returnedTickets: 0,
//     totalUsers: 0,
//     totalBusOwners: 0,
//     totalDrivers: 0,
//     recentBookings: [],
//     usersList: [],
//     busOwnersList: [],
//     driversList: [],
//     conductorsList: [],
//     allBookings: [],
//     allBusOwners: [],
//     allDrivers: [],
//     allConductors: [],
//     allUsers: [],
//     chartLabels: [],
//     bookingData: [],
//     cancelData: [],
//     paymentMethods: {},
//     topRoutes: []
//   });

//   const [selectedPeriod, setSelectedPeriod] = useState('all');
//   const [loading, setLoading] = useState(true);
//   const [modal, setModal] = useState({
//     isOpen: false,
//     type: '',
//     title: '',
//     data: [],
//     columns: []
//   });

//   const bookingChartRef = useRef(null);
//   const paymentMethodsChartRef = useRef(null);
//   const revenueChartRef = useRef(null);

//   useEffect(() => {
//     fetchAllData();
//   }, [selectedPeriod]);

//   useEffect(() => {
//     if (!loading && dashboardData.bookingData) {
//       createCharts();
//     }

//     return () => {
//       if (bookingChartRef.current) bookingChartRef.current.destroy();
//       if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();
//       if (revenueChartRef.current) revenueChartRef.current.destroy();
//     };
//   }, [dashboardData, loading]);

//   const getDateRange = (period) => {
//     const now = new Date();
//     const dateRange = { dateFrom: null, dateTo: null };

//     switch (period) {
//       case 'Today':
//         const today = new Date(now);
//         today.setHours(0, 0, 0, 0);
//         dateRange.dateFrom = today.toISOString();
//         const todayEnd = new Date(now);
//         todayEnd.setHours(23, 59, 59, 999);
//         dateRange.dateTo = todayEnd.toISOString();
//         break;

//       case 'This Week':
//         const startOfWeek = new Date(now);
//         const dayOfWeek = now.getDay();
//         startOfWeek.setDate(now.getDate() - dayOfWeek);
//         startOfWeek.setHours(0, 0, 0, 0);
//         dateRange.dateFrom = startOfWeek.toISOString();
//         break;

//       case 'This Month':
//         const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
//         startOfMonth.setHours(0, 0, 0, 0);
//         dateRange.dateFrom = startOfMonth.toISOString();
//         break;

//       case 'This Year':
//         const startOfYear = new Date(now.getFullYear(), 0, 1);
//         startOfYear.setHours(0, 0, 0, 0);
//         dateRange.dateFrom = startOfYear.toISOString();
//         break;

//       case 'all':
//       default:
//         dateRange.dateFrom = null;
//         dateRange.dateTo = null;
//         break;
//     }

//     return dateRange;
//   };

//   const fetchAllData = async () => {
//     try {
//       setLoading(true);

//       const config = {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       };

//       const dateRange = getDateRange(selectedPeriod);

//       const dashboardResponse = await api.get('/dashboard', {
//         ...config,
//         params: { period: selectedPeriod }
//       });

//       const bookingsParams = {};
//       if (dateRange.dateFrom) {
//         bookingsParams.dateFrom = dateRange.dateFrom;
//       }
//       if (dateRange.dateTo) {
//         bookingsParams.dateTo = dateRange.dateTo;
//       }

//       bookingsParams.page = 1;
//       bookingsParams.limit = 100;

//       const bookingsResponse = await api.get('/bookings', {
//         ...config,
//         params: bookingsParams
//       });

//       const [
//         usersResponse,
//         busOwnersResponse,
//         driversResponse,
//         conductorsResponse
//       ] = await Promise.all([
//         api.get('/users', config),
//         api.get('/bus-owners', config),
//         api.get('/drivers', config),
//         api.get('/conductors', config)
//       ]);

//       const dashboardResult = dashboardResponse.data;
//       const stats = dashboardResult.stats || {};
//       const chartDataFromBackend = dashboardResult.chartData || {};

//       const users = usersResponse.data.users || [];
//       const busOwners = busOwnersResponse.data.busOwners || [];
//       const drivers = driversResponse.data.drivers || [];
//       const conductors = conductorsResponse.data.conductors || [];
//       const bookings = bookingsResponse.data.bookings || [];

//       const filteredBookings = bookings;

//       const { bookingData, cancelData } = processChartData(
//         chartDataFromBackend.bookingTrends || [],
//         chartDataFromBackend.labels || [],
//         selectedPeriod
//       );

//       const paymentMethods = processPaymentMethods(chartDataFromBackend.paymentMethods || []);

//       setDashboardData({
//         revenue: stats.totalRevenue || stats.paymentCollectionRevenue || 0,
//         totalTickets: stats.totalBookings || stats.ticketOrdered || 0,
//         bookedTickets: stats.bookedTickets || 0,
//         returnedTickets: stats.refundedTickets || 0,
//         totalUsers: stats.totalUsers || users.length,
//         totalBusOwners: stats.totalOwners || busOwners.length,
//         totalDrivers: drivers.length,
//         recentBookings: filteredBookings.slice(0, 10),
//         usersList: users.slice(0, 5),
//         busOwnersList: busOwners.slice(0, 5),
//         driversList: drivers.slice(0, 5),
//         conductorsList: conductors.slice(0, 5),
//         allBookings: filteredBookings,
//         allUsers: users,
//         allBusOwners: busOwners,
//         allDrivers: drivers,
//         allConductors: conductors,
//         chartLabels: chartDataFromBackend.labels || [],
//         bookingData: bookingData,
//         cancelData: cancelData,
//         paymentMethods: paymentMethods,
//         topRoutes: chartDataFromBackend.topRoutes || []
//       });

//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
//       setLoading(false);
//     }
//   };

//   const processChartData = (bookingTrends, labels, period) => {
//     let bookingData = new Array(labels.length).fill(0);
//     let cancelData = new Array(labels.length).fill(0);

//     bookingTrends.forEach(item => {
//       let index = 0;

//       if (period === 'Today') {
//         index = item._id?.hour || 0;
//       } else if (period === 'This Week') {
//         index = (item._id?.dayOfWeek || 1) - 1;
//       } else if (period === 'This Month') {
//         index = (item._id?.day || 1) - 1;
//       } else if (period === 'This Year') {
//         index = (item._id?.month || 1) - 1;
//       } else {
//         index = (item._id?.month || 1) - 1;
//       }

//       if (index >= 0 && index < labels.length) {
//         bookingData[index] = item.confirmedBookings || item.totalBookings || 0;
//         cancelData[index] = item.cancelledBookings || 0;
//       }
//     });

//     return { bookingData, cancelData };
//   };

//   const processPaymentMethods = (paymentMethods) => {
//     const methods = {
//       cash: 0,
//       card: 0,
//       upi: 0,
//       other: 0
//     };

//     paymentMethods.forEach(method => {
//       const methodName = (method._id || '').toLowerCase();
//       const count = method.count || 0;

//       if (methodName.includes('cash')) {
//         methods.cash = count;
//       } else if (methodName.includes('card')) {
//         methods.card = count;
//       } else if (methodName.includes('upi')) {
//         methods.upi = count;
//       } else {
//         methods.other += count;
//       }
//     });

//     return methods;
//   };

//   const createCharts = () => {
//     const bookingCtx = document.getElementById('bookingChart');
//     if (bookingCtx) {
//       if (bookingChartRef.current) bookingChartRef.current.destroy();

//       bookingChartRef.current = new Chart(bookingCtx, {
//         type: 'bar',
//         data: {
//           labels: dashboardData.chartLabels,
//           datasets: [
//             {
//               label: 'Confirmed Bookings',
//               data: dashboardData.bookingData,
//               backgroundColor: '#4CAF50',
//               borderColor: '#388E3C',
//               borderWidth: 1,
//               borderRadius: 4,
//             },
//             {
//               label: 'Cancelled Bookings',
//               data: dashboardData.cancelData,
//               backgroundColor: '#F44336',
//               borderColor: '#D32F2F',
//               borderWidth: 1,
//               borderRadius: 4,
//             }
//           ]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: {
//               position: 'top',
//               labels: { usePointStyle: true, padding: 15, font: { size: 11 } }
//             },
//             title: {
//               display: true,
//               text: `Ticket Bookings & Cancellations - ${getPeriodLabel()}`,
//               font: { size: 14, weight: 'bold' },
//               padding: 10
//             },
//             tooltip: {
//               callbacks: {
//                 label: function (context) {
//                   return `${context.dataset.label}: ${context.parsed.y}`;
//                 }
//               }
//             }
//           },
//           scales: {
//             x: {
//               grid: { display: false },
//               ticks: {
//                 font: { size: 10 },
//                 maxRotation: 45,
//                 minRotation: 45
//               }
//             },
//             y: {
//               beginAtZero: true,
//               ticks: {
//                 font: { size: 10 },
//                 callback: function (value) {
//                   return value >= 1000 ? (value / 1000).toFixed(1) + 'k' : value;
//                 }
//               },
//               grid: { color: '#f0f0f0' }
//             }
//           }
//         }
//       });
//     }

//     const paymentCtx = document.getElementById('paymentMethodsChart');
//     if (paymentCtx) {
//       if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();

//       const paymentData = dashboardData.paymentMethods;
//       const labels = Object.keys(paymentData).map(key => key.toUpperCase());
//       const data = Object.values(paymentData);
//       const total = data.reduce((a, b) => a + b, 0);

//       paymentMethodsChartRef.current = new Chart(paymentCtx, {
//         type: 'pie',
//         data: {
//           labels: labels,
//           datasets: [{
//             data: data,
//             backgroundColor: ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0'],
//             borderColor: '#fff',
//             borderWidth: 2,
//             hoverOffset: 8
//           }]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: {
//               position: 'bottom',
//               labels: { usePointStyle: true, padding: 15, font: { size: 11 } }
//             },
//             title: {
//               display: true,
//               text: `Payment Methods - ${getPeriodLabel()}`,
//               font: { size: 14, weight: 'bold' },
//               padding: 10
//             },
//             tooltip: {
//               callbacks: {
//                 label: function (context) {
//                   const percentage = ((context.raw / total) * 100).toFixed(1);
//                   return `${context.label}: ${context.raw} (${percentage}%)`;
//                 }
//               }
//             }
//           }
//         }
//       });
//     }
//   };

//   const getPeriodLabel = () => {
//     switch (selectedPeriod) {
//       case 'Today': return 'Today';
//       case 'This Week': return 'This Week';
//       case 'This Month': return 'This Month';
//       case 'This Year': return 'This Year';
//       default: return 'All Time';
//     }
//   };

//   const fetchFilteredBookingsForModal = async (page = 1, limit = 50) => {
//     try {
//       const config = {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       };

//       const dateRange = getDateRange(selectedPeriod);
//       const params = { page, limit };

//       if (dateRange.dateFrom) {
//         params.dateFrom = dateRange.dateFrom;
//       }
//       if (dateRange.dateTo) {
//         params.dateTo = dateRange.dateTo;
//       }

//       const response = await api.get('/bookings', {
//         ...config,
//         params
//       });

//       return response.data;
//     } catch (error) {
//       console.error('Error fetching filtered bookings:', error);
//       return { bookings: [], total: 0 };
//     }
//   };

//   const openModal = async (title, data, columns) => {
//     if (title === 'Bookings') {
//       setLoading(true);
//       const result = await fetchFilteredBookingsForModal(1, 200);
//       setModal({
//         isOpen: true,
//         type: title.toLowerCase().replace(' ', '-'),
//         title: `All ${title} - ${getPeriodLabel()}`,
//         data: result.bookings,
//         columns: [...columns, 'Status'],
//         total: result.total
//       });
//       setLoading(false);
//     } else {
//       setModal({
//         isOpen: true,
//         type: title.toLowerCase().replace(' ', '-'),
//         title: `All ${title} - ${getPeriodLabel()}`,
//         data: data,
//         columns: [...columns, 'Status']
//       });
//     }
//   };

//   const closeModal = () => {
//     setModal({
//       isOpen: false,
//       type: '',
//       title: '',
//       data: [],
//       columns: []
//     });
//   };

//   const StatsCard = ({ title, value, subtitle, icon, color = "#2f92c4" }) => (
//     <div className="stats-card" style={{ borderLeftColor: color }}>
//       <div className="stats-content">
//         <div className="stats-info">
//           <h3>{title}</h3>
//           <h2>{typeof value === 'number' ? value.toLocaleString() : value}</h2>
//           <p>{subtitle}</p>
//         </div>
//         <div className="stats-icon">{icon}</div>
//       </div>
//     </div>
//   );

//   const UserListCard = ({ title, data, allData, columns }) => (
//     <div className="list-card">
//       <div className="list-header">
//         <h3>{title}</h3>
//         <button
//           className="view-all-btn"
//           onClick={() => openModal(title, allData, columns)}
//         >
//           View All
//         </button>
//       </div>
//       <div className="list-content">
//         <table>
//           <thead>
//             <tr>
//               {columns.map((col, index) => (
//                 <th key={index}>{col}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {data.slice(0, 5).map((item, index) => (
//               <tr key={item._id || item.id || index}>
//                 {columns.map((col, cellIndex) => {
//                   let value = '';

//                   switch (col) {
//                     case 'Name':
//                       value = item.name || 'N/A';
//                       break;
//                     case 'Email':
//                       value = item.email || 'N/A';
//                       break;
//                     case 'Phone':
//                       value = item.phone || item.mobileNumber || 'N/A';
//                       break;
//                     case 'Company':
//                       value = item.company || 'N/A';
//                       break;
//                     case 'Buses':
//                       value = item.busCount || item.buses || 0;
//                       break;
//                     case 'Bus':
//                       value = item.assignedBus?.busNumber || item.bus || 'N/A';
//                       break;
//                     case 'Experience':
//                       value = item.experience || 'N/A';
//                       break;
//                     case 'Joined':
//                       value = item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A';
//                       break;
//                     case 'License':
//                       value = item.licenseNumber || 'N/A';
//                       break;
//                     default:
//                       value = item[col.toLowerCase()] || 'N/A';
//                   }

//                   return <td key={cellIndex}>{value}</td>;
//                 })}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="quick-stats">
//         <div className="quick-stat">
//           <h4>Total</h4>
//           <p>{allData.length}</p>
//         </div>
//         <div className="quick-stat">
//           <h4>Active</h4>
//           <p>{allData.filter(item => item.isActive !== false).length}</p>
//         </div>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <div className="dashboard">
//         <div className="dashboard-header">
//           <div className="skeleton-header"></div>
//           <div className="skeleton-filter"></div>
//         </div>

//         <div className="stats-grid">
//           {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <div className="charts-container">
//           <div className="chart-row">
//             <SkeletonChartCard />
//             <SkeletonChartCard />
//             <SkeletonChartCard />
//           </div>
//         </div>

//         <div className="content-container">
//           <div className="charts-section">
//             <SkeletonChartCard />
//             <SkeletonChartCard />
//           </div>

//           <div className="lists-section">
//             <SkeletonUserListCard />
//             <SkeletonUserListCard />
//             <SkeletonUserListCard />
//             <SkeletonUserListCard />
//           </div>
//         </div>

//         <SkeletonRecentBookings />
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard">
//       <div className="dashboard-header">
//         <h1>Dashboard - {getPeriodLabel()} View</h1>
//         <div className="date-filter">
//           <select
//             value={selectedPeriod}
//             onChange={(e) => setSelectedPeriod(e.target.value)}
//           >
//             <option value="all">All Time</option>
//             <option value="Today">Today</option>
//             <option value="This Week">This Week</option>
//             <option value="This Month">This Month</option>
//             <option value="This Year">This Year</option>
//           </select>
//         </div>
//       </div>

//       <div className="stats-grid">
//         <StatsCard
//           title="TOTAL REVENUE"
//           value={`₹${dashboardData.revenue.toLocaleString()}`}
//           subtitle={`${getPeriodLabel()} revenue`}
//           icon="💰"
//           color="#4CAF50"
//         />
//         <StatsCard
//           title="TOTAL BOOKINGS"
//           value={dashboardData.totalTickets}
//           subtitle={`${getPeriodLabel()} bookings`}
//           icon="🎫"
//           color="#2196F3"
//         />
//         <StatsCard
//           title="CONFIRMED BOOKINGS"
//           value={dashboardData.bookedTickets}
//           subtitle={`${getPeriodLabel()} confirmed`}
//           icon="✅"
//           color="#4CAF50"
//         />
//         <StatsCard
//           title="CANCELLED BOOKINGS"
//           value={dashboardData.returnedTickets}
//           subtitle={`${getPeriodLabel()} cancelled`}
//           icon="↩️"
//           color="#F44336"
//         />
//         <StatsCard
//           title="TOTAL USERS"
//           value={dashboardData.totalUsers}
//           subtitle={`${getPeriodLabel()} users`}
//           icon="👥"
//           color="#9C27B0"
//         />
//         <StatsCard
//           title="BUS OWNERS"
//           value={dashboardData.totalBusOwners}
//           subtitle="Active partners"
//           icon="🚌"
//           color="#FF9800"
//         />
//         <StatsCard
//           title="BUS DRIVERS"
//           value={dashboardData.totalDrivers}
//           subtitle="Active drivers"
//           icon="👨‍✈️"
//           color="#795548"
//         />
//       </div>

//       <div className="charts-container">
//         <div className="chart-row">
//           <div className="chart-card" style={{ flex: 2 }}>
//             <div className="chart-header">
//               <h3>Booking Trends</h3>
//             </div>
//             <div className="chart-wrapper" style={{ height: '400px' }}>
//               <canvas id="bookingChart"></canvas>
//             </div>
//           </div>
//           <div className="chart-card" style={{ flex: 1 }}>
//             <div className="chart-header">
//               <h3>Payment Methods</h3>
//             </div>
//             <div className="chart-wrapper" style={{ height: '400px' }}>
//               <canvas id="paymentMethodsChart"></canvas>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="content-container">
//         <div className="lists-section">
//           <UserListCard
//             title="Bus Owners"
//             data={dashboardData.busOwnersList}
//             allData={dashboardData.allBusOwners}
//             columns={['Name', 'Phone', 'Email', 'Buses']}
//           />

//           <UserListCard
//             title="Bus Drivers"
//             data={dashboardData.driversList}
//             allData={dashboardData.allDrivers}
//             columns={['Name', 'Phone', 'Bus', 'Experience', 'License']}
//           />

//           <UserListCard
//             title="Bus Conductors"
//             data={dashboardData.conductorsList}
//             allData={dashboardData.allConductors}
//             columns={['Name', 'Phone', 'Bus']}
//           />

//           <UserListCard
//             title="Recent Users"
//             data={dashboardData.usersList}
//             allData={dashboardData.allUsers}
//             columns={['Name', 'Email', 'Phone']}
//           />
//         </div>
//       </div>

//       <div className="recent-bookings">
//         <div className="recent-header">
//           <h3>Recent Bookings - {getPeriodLabel()}</h3>
//           <button
//             className="view-all-btn"
//             onClick={() => openModal('Bookings', dashboardData.allBookings, ['PNR', 'Passenger', 'Route', 'Amount', 'Date', 'Status'])}
//           >
//             View All
//           </button>
//         </div>
//         <div className="bookings-table">
//           <table>
//             <thead>
//               <tr>
//                 <th>PNR Number</th>
//                 <th>Passenger</th>
//                 <th>Route</th>
//                 <th>Amount</th>
//                 <th>Date</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {dashboardData.recentBookings.map((booking) => (
//                 <tr key={booking.id || booking._id}>
//                   <td className="pnr">{booking.pnr || 'N/A'}</td>
//                   <td className="user">{booking.user?.name || booking.passengerName || 'N/A'}</td>
//                   <td className="route">{booking.route ? `${booking.route.from} to ${booking.route.to}` : 'N/A'}</td>
//                   <td className="amount">₹{booking.amount || 0}</td>
//                   <td className="date">{booking.bookedOn || booking.date || 'N/A'}</td>
//                   <td>
//                     <span className={`status ${(booking.status || 'confirmed').toLowerCase()}`}>
//                       {booking.status || 'Confirmed'}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {dashboardData.recentBookings.length === 0 && (
//             <div className="no-data">
//               <p>No bookings found for {getPeriodLabel()}</p>
//             </div>
//           )}
//         </div>
//       </div>

//       <Modal
//         isOpen={modal.isOpen}
//         title={modal.title}
//         data={modal.data}
//         columns={modal.columns}
//         total={modal.total}
//         onClose={closeModal}
//         periodLabel={getPeriodLabel()}
//       />
//     </div>
//   );
// };

// export default Home;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Chart, registerables } from 'chart.js';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import '../../Styles/Dashboard.css';
import api from '../../Services/api';
import { Icon, BusSvg, StatCard, Field, Avatar } from './PrimaryUI';

Chart.register(...registerables);

// ---------- helpers ----------
const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 })
    .format(amount || 0);
const safeNum = (v) => (v === null || v === undefined ? 0 : Number(v) || 0);
const safeStr = (v) => (v === null || v === undefined ? '' : String(v));

const PERIODS = [
  { value: 'all',       label: 'All Time' },
  { value: 'Today',     label: 'Today' },
  { value: 'This Week', label: 'This Week' },
  { value: 'This Month',label: 'This Month' },
  { value: 'This Year', label: 'This Year' },
];

const PERIOD_LABEL = (p) => PERIODS.find(x => x.value === p)?.label || 'All Time';

// ============================================================
// Row renderer for tables (shared between list cards + modal)
// ============================================================
const renderCell = (item, col, colIndex) => {
  let value = '';
  if (col === 'Status') {
    const v = item.isActive === false ? 'inactive' : (item.status || 'active');
    return (
      <td key={colIndex}>
        <span className={`prm-status ${String(v).toLowerCase() === 'inactive' ? 'inactive' : 'active'}`}>
          {String(v).charAt(0).toUpperCase() + String(v).slice(1)}
        </span>
      </td>
    );
  }
  switch (col) {
    case 'Name':       value = item.name || 'N/A'; break;
    case 'Email':      value = item.email || 'N/A'; break;
    case 'Phone':      value = item.phone || item.mobileNumber || 'N/A'; break;
    case 'Company':    value = item.company || 'N/A'; break;
    case 'Buses':      value = item.busCount || item.buses || 0; break;
    case 'Bus':        value = item.assignedBus?.busNumber || item.bus || 'N/A'; break;
    case 'Experience': value = item.experience || 'N/A'; break;
    case 'Joined':     value = item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A'; break;
    case 'License':    value = item.licenseNumber || 'N/A'; break;
    case 'PNR':        value = item.pnr || 'N/A'; break;
    case 'Passenger':  value = item.user?.name || item.name || 'N/A'; break;
    case 'Route':      value = item.route ? `${item.route.from} to ${item.route.to}` : 'N/A'; break;
    case 'Amount':     value = formatCurrency(item.amount || item.paymentAmount || 0); break;
    case 'Date':       value = item.bookedOn || item.date || (item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A'); break;
    default:           value = item[col.toLowerCase()] || 'N/A';
  }
  return <td key={colIndex}>{value}</td>;
};

// ============================================================
// List Card
// ============================================================
const UserListCard = ({ icon, title, data, allData, columns, onViewAll }) => (
  <div className="prm-card cr-card" style={{ height: '100%' }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <span className="prm-form-badge" style={{ width: 40, height: 40 }}>
          <Icon name={icon} size={18} />
        </span>
        <div>
          <h3 className="prm-card-title">{title}</h3>
          <div className="prm-card-sub">
            {allData.length} total · {allData.filter(x => x.isActive !== false).length} active
          </div>
        </div>
      </div>
      <button className="prm-btn ghost sm" onClick={onViewAll} disabled={allData.length === 0}>
        <Icon name="eye" size={13} /> View All
      </button>
    </div>

    <div className="prm-table-wrap" style={{ maxHeight: 260 }}>
      <table className="prm-table">
        <thead>
          <tr>{columns.map((c, i) => <th key={i}>{c}</th>)}</tr>
        </thead>
        <tbody>
          {data.slice(0, 5).map((item, i) => (
            <tr key={item._id || item.id || i}>
              {columns.map((col, ci) => renderCell(item, col, ci))}
            </tr>
          ))}
          {data.length === 0 && (
            <tr><td colSpan={columns.length} style={{ textAlign: 'center', color: '#a0aec0' }}>No data</td></tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const Home = () => {
  const { token } = useSelector((state) => state.user);

  const [dashboardData, setDashboardData] = useState({
    revenue: 0,
    totalTickets: 0,
    bookedTickets: 0,
    returnedTickets: 0,
    totalUsers: 0,
    totalBusOwners: 0,
    totalDrivers: 0,
    recentBookings: [],
    usersList: [], busOwnersList: [], driversList: [], conductorsList: [],
    allBookings: [], allBusOwners: [], allDrivers: [], allConductors: [], allUsers: [],
    chartLabels: [], bookingData: [], cancelData: [],
    paymentMethods: {}, topRoutes: []
  });

  const [selectedPeriod, setSelectedPeriod] = useState('all');
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [modal, setModal] = useState({ isOpen: false, type: '', title: '', data: [], columns: [], total: 0 });

  const bookingChartRef = useRef(null);
  const paymentMethodsChartRef = useRef(null);
  const revenueChartRef = useRef(null);

  // ---------- fetch ----------
  useEffect(() => {
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPeriod]);

  useEffect(() => {
    if (!loading && dashboardData.bookingData) createCharts();
    return () => {
      if (bookingChartRef.current) bookingChartRef.current.destroy();
      if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();
      if (revenueChartRef.current) revenueChartRef.current.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardData, loading]);

  const getDateRange = (period) => {
    const now = new Date();
    const dateRange = { dateFrom: null, dateTo: null };
    switch (period) {
      case 'Today': {
        const today = new Date(now); today.setHours(0, 0, 0, 0);
        dateRange.dateFrom = today.toISOString();
        const todayEnd = new Date(now); todayEnd.setHours(23, 59, 59, 999);
        dateRange.dateTo = todayEnd.toISOString();
        break;
      }
      case 'This Week': {
        const startOfWeek = new Date(now);
        const dayOfWeek = now.getDay();
        startOfWeek.setDate(now.getDate() - dayOfWeek);
        startOfWeek.setHours(0, 0, 0, 0);
        dateRange.dateFrom = startOfWeek.toISOString();
        break;
      }
      case 'This Month': {
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        startOfMonth.setHours(0, 0, 0, 0);
        dateRange.dateFrom = startOfMonth.toISOString();
        break;
      }
      case 'This Year': {
        const startOfYear = new Date(now.getFullYear(), 0, 1);
        startOfYear.setHours(0, 0, 0, 0);
        dateRange.dateFrom = startOfYear.toISOString();
        break;
      }
      default: break;
    }
    return dateRange;
  };

  const fetchAllData = async () => {
    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const dateRange = getDateRange(selectedPeriod);

      const dashboardResponse = await api.get('/dashboard', { ...config, params: { period: selectedPeriod } });

      const bookingsParams = { page: 1, limit: 100 };
      if (dateRange.dateFrom) bookingsParams.dateFrom = dateRange.dateFrom;
      if (dateRange.dateTo) bookingsParams.dateTo = dateRange.dateTo;
      const bookingsResponse = await api.get('/bookings', { ...config, params: bookingsParams });

      const [usersResponse, busOwnersResponse, driversResponse, conductorsResponse] = await Promise.all([
        api.get('/users', config),
        api.get('/bus-owners', config),
        api.get('/drivers', config),
        api.get('/conductors', config)
      ]);

      const dashboardResult = dashboardResponse.data;
      const stats = dashboardResult.stats || {};
      const chartDataFromBackend = dashboardResult.chartData || {};

      const users = usersResponse.data.users || [];
      const busOwners = busOwnersResponse.data.busOwners || [];
      const drivers = driversResponse.data.drivers || [];
      const conductors = conductorsResponse.data.conductors || [];
      const bookings = bookingsResponse.data.bookings || [];

      const { bookingData, cancelData } = processChartData(
        chartDataFromBackend.bookingTrends || [],
        chartDataFromBackend.labels || [],
        selectedPeriod
      );

      const paymentMethods = processPaymentMethods(chartDataFromBackend.paymentMethods || []);

      setDashboardData({
        revenue: stats.totalRevenue || stats.paymentCollectionRevenue || 0,
        totalTickets: stats.totalBookings || stats.ticketOrdered || 0,
        bookedTickets: stats.bookedTickets || 0,
        returnedTickets: stats.refundedTickets || 0,
        totalUsers: stats.totalUsers || users.length,
        totalBusOwners: stats.totalOwners || busOwners.length,
        totalDrivers: drivers.length,
        recentBookings: bookings.slice(0, 10),
        usersList: users.slice(0, 5),
        busOwnersList: busOwners.slice(0, 5),
        driversList: drivers.slice(0, 5),
        conductorsList: conductors.slice(0, 5),
        allBookings: bookings,
        allUsers: users,
        allBusOwners: busOwners,
        allDrivers: drivers,
        allConductors: conductors,
        chartLabels: chartDataFromBackend.labels || [],
        bookingData,
        cancelData,
        paymentMethods,
        topRoutes: chartDataFromBackend.topRoutes || []
      });

      setLoading(false);
      setFirstLoad(false);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      toast.error('Failed to load dashboard data');
      setLoading(false);
      setFirstLoad(false);
    }
  };

  const processChartData = (bookingTrends, labels, period) => {
    const bookingData = new Array(labels.length).fill(0);
    const cancelData = new Array(labels.length).fill(0);

    bookingTrends.forEach(item => {
      let index = 0;
      if (period === 'Today') index = item._id?.hour || 0;
      else if (period === 'This Week') index = (item._id?.dayOfWeek || 1) - 1;
      else if (period === 'This Month') index = (item._id?.day || 1) - 1;
      else if (period === 'This Year') index = (item._id?.month || 1) - 1;
      else index = (item._id?.month || 1) - 1;

      if (index >= 0 && index < labels.length) {
        bookingData[index] = item.confirmedBookings || item.totalBookings || 0;
        cancelData[index] = item.cancelledBookings || 0;
      }
    });
    return { bookingData, cancelData };
  };

  const processPaymentMethods = (paymentMethods) => {
    const methods = { cash: 0, card: 0, upi: 0, other: 0 };
    paymentMethods.forEach(method => {
      const methodName = (method._id || '').toLowerCase();
      const count = method.count || 0;
      if (methodName.includes('cash')) methods.cash = count;
      else if (methodName.includes('card')) methods.card = count;
      else if (methodName.includes('upi')) methods.upi = count;
      else methods.other += count;
    });
    return methods;
  };

  const createCharts = () => {
    const bookingCtx = document.getElementById('bookingChart');
    if (bookingCtx) {
      if (bookingChartRef.current) bookingChartRef.current.destroy();
      bookingChartRef.current = new Chart(bookingCtx, {
        type: 'bar',
        data: {
          labels: dashboardData.chartLabels,
          datasets: [
            { label: 'Confirmed Bookings', data: dashboardData.bookingData, backgroundColor: '#4CAF50', borderColor: '#388E3C', borderWidth: 1, borderRadius: 4 },
            { label: 'Cancelled Bookings', data: dashboardData.cancelData, backgroundColor: '#F44336', borderColor: '#D32F2F', borderWidth: 1, borderRadius: 4 }
          ]
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: {
            legend: { position: 'top', labels: { usePointStyle: true, padding: 15, font: { size: 11 } } },
            title: { display: true, text: `Ticket Bookings & Cancellations - ${PERIOD_LABEL(selectedPeriod)}`, font: { size: 14, weight: 'bold' }, padding: 10 },
            tooltip: { callbacks: { label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y}` } }
          },
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 45 } },
            y: { beginAtZero: true, ticks: { font: { size: 10 }, callback: (v) => v >= 1000 ? (v / 1000).toFixed(1) + 'k' : v }, grid: { color: '#f0f0f0' } }
          }
        }
      });
    }

    const paymentCtx = document.getElementById('paymentMethodsChart');
    if (paymentCtx) {
      if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();
      const paymentData = dashboardData.paymentMethods;
      const labels = Object.keys(paymentData).map(key => key.toUpperCase());
      const data = Object.values(paymentData);
      const total = data.reduce((a, b) => a + b, 0);

      paymentMethodsChartRef.current = new Chart(paymentCtx, {
        type: 'pie',
        data: {
          labels,
          datasets: [{ data, backgroundColor: ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0'], borderColor: '#fff', borderWidth: 2, hoverOffset: 8 }]
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: {
            legend: { position: 'bottom', labels: { usePointStyle: true, padding: 15, font: { size: 11 } } },
            title: { display: true, text: `Payment Methods - ${PERIOD_LABEL(selectedPeriod)}`, font: { size: 14, weight: 'bold' }, padding: 10 },
            tooltip: { callbacks: { label: (ctx) => {
              const percentage = ((ctx.raw / total) * 100).toFixed(1);
              return `${ctx.label}: ${ctx.raw} (${percentage}%)`;
            } } }
          }
        }
      });
    }
  };

  // ---------- modal ----------
  const fetchFilteredBookingsForModal = async (page = 1, limit = 50) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const dateRange = getDateRange(selectedPeriod);
      const params = { page, limit };
      if (dateRange.dateFrom) params.dateFrom = dateRange.dateFrom;
      if (dateRange.dateTo) params.dateTo = dateRange.dateTo;
      const response = await api.get('/bookings', { ...config, params });
      return response.data;
    } catch (error) {
      console.error('Error fetching filtered bookings:', error);
      return { bookings: [], total: 0 };
    }
  };

  const openModal = async (title, data, columns) => {
    if (title === 'Bookings') {
      setLoading(true);
      const result = await fetchFilteredBookingsForModal(1, 200);
      setModal({
        isOpen: true,
        type: title.toLowerCase().replace(' ', '-'),
        title: `All ${title}`,
        data: result.bookings,
        columns: [...columns],
        total: result.total
      });
      setLoading(false);
    } else {
      setModal({
        isOpen: true,
        type: title.toLowerCase().replace(' ', '-'),
        title: `All ${title}`,
        data,
        columns: [...columns],
        total: data.length
      });
    }
  };

  const closeModal = () => setModal({ isOpen: false, type: '', title: '', data: [], columns: [], total: 0 });

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="grid" size={13} /> Dashboard</span>
          <h1>Loading…</h1><p>Fetching analytics…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const periodLabel = PERIOD_LABEL(selectedPeriod);

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="grid" size={13} /> Overview</span>
          <h1>Dashboard</h1>
          <p>Live snapshot of revenue, bookings, users, and fleet partners.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-chips" style={{ flexWrap: 'wrap' }}>
            {PERIODS.map(p => (
              <button
                key={p.value}
                className={`prm-chip ${selectedPeriod === p.value ? 'active' : ''}`}
                onClick={() => setSelectedPeriod(p.value)}
              >
                {p.label}
              </button>
            ))}
          </div>
          <button className="pbo-icon-btn" onClick={fetchAllData} title="Refresh">
            <Icon name="refresh" size={17} />
          </button>
        </div>
      </div>

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="wallet" tone="green"  label="Total Revenue"        value={safeNum(dashboardData.revenue)}          hint={`${periodLabel} revenue`}       delay={80} />
        <StatCard icon="ticket" tone="cyan"   label="Total Bookings"       value={safeNum(dashboardData.totalTickets)}     hint={`${periodLabel} bookings`}      delay={140} />
        <StatCard icon="check"  tone="green"  label="Confirmed"            value={safeNum(dashboardData.bookedTickets)}    hint={`${periodLabel} confirmed`}     delay={200} />
        <StatCard icon="x"      tone="inactive" label="Cancelled"          value={safeNum(dashboardData.returnedTickets)}  hint={`${periodLabel} cancelled`}     delay={260} />
        <StatCard icon="users"  tone="indigo" label="Total Users"          value={safeNum(dashboardData.totalUsers)}       hint={`${periodLabel} users`}         delay={320} />
        <StatCard icon="bus"    tone="amber"  label="Bus Owners"           value={safeNum(dashboardData.totalBusOwners)}   hint="Active partners"                delay={380} />
        <StatCard icon="users"  tone="pending" label="Bus Drivers"         value={safeNum(dashboardData.totalDrivers)}     hint="Active drivers"                 delay={440} />
      </div>

      {/* CHARTS */}
      <div className="prm-grid" style={{ gridTemplateColumns: '2fr 1fr', marginBottom: 16 }}>
        <div className="prm-card cr-card">
          <div className="prm-card-top">
            <h3 className="prm-card-title">Booking Trends</h3>
          </div>
          <div style={{ height: 400 }}>
            <canvas id="bookingChart"></canvas>
          </div>
        </div>
        <div className="prm-card cr-card">
          <div className="prm-card-top">
            <h3 className="prm-card-title">Payment Methods</h3>
          </div>
          <div style={{ height: 400 }}>
            <canvas id="paymentMethodsChart"></canvas>
          </div>
        </div>
      </div>

      {/* LISTS */}
      <div className="prm-section-title">Fleet & Users</div>
      <div className="prm-grid">
        <UserListCard
          icon="bus"
          title="Bus Owners"
          data={dashboardData.busOwnersList}
          allData={dashboardData.allBusOwners}
          columns={['Name', 'Phone', 'Email', 'Buses']}
          onViewAll={() => openModal('Bus Owners', dashboardData.allBusOwners, ['Name', 'Phone', 'Email', 'Buses', 'Status'])}
        />
        <UserListCard
          icon="users"
          title="Bus Drivers"
          data={dashboardData.driversList}
          allData={dashboardData.allDrivers}
          columns={['Name', 'Phone', 'Bus', 'Experience', 'License']}
          onViewAll={() => openModal('Bus Drivers', dashboardData.allDrivers, ['Name', 'Phone', 'Bus', 'Experience', 'License', 'Status'])}
        />
        <UserListCard
          icon="users"
          title="Bus Conductors"
          data={dashboardData.conductorsList}
          allData={dashboardData.allConductors}
          columns={['Name', 'Phone', 'Bus']}
          onViewAll={() => openModal('Bus Conductors', dashboardData.allConductors, ['Name', 'Phone', 'Bus', 'Status'])}
        />
        <UserListCard
          icon="user"
          title="Recent Users"
          data={dashboardData.usersList}
          allData={dashboardData.allUsers}
          columns={['Name', 'Email', 'Phone']}
          onViewAll={() => openModal('Recent Users', dashboardData.allUsers, ['Name', 'Email', 'Phone', 'Status'])}
        />
      </div>

      {/* RECENT BOOKINGS */}
      <div className="prm-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Recent Bookings · {periodLabel}</span>
        <button
          className="prm-btn ghost sm"
          onClick={() => openModal('Bookings', dashboardData.allBookings, ['PNR', 'Passenger', 'Route', 'Amount', 'Date', 'Status'])}
        >
          <Icon name="eye" size={13} /> View All
        </button>
      </div>
      <div className="prm-table-wrap" style={{ marginBottom: 16 }}>
        <table className="prm-table">
          <thead>
            <tr>
              <th>PNR</th><th>Passenger</th><th>Route</th><th>Amount</th><th>Date</th><th>Status</th>
            </tr>
          </thead>
          <tbody>
            {dashboardData.recentBookings.map((b) => (
              <tr key={b.id || b._id}>
                <td><b>{safeStr(b.pnr) || 'N/A'}</b></td>
                <td>{safeStr(b.user?.name || b.passengerName) || 'N/A'}</td>
                <td>{b.route ? `${b.route.from} to ${b.route.to}` : 'N/A'}</td>
                <td>{formatCurrency(b.amount)}</td>
                <td>{safeStr(b.bookedOn || b.date) || 'N/A'}</td>
                <td>
                  <span className={`prm-status ${(b.status || 'confirmed').toLowerCase() === 'confirmed' ? 'active' : 'inactive'}`}>
                    {safeStr(b.status) || 'Confirmed'}
                  </span>
                </td>
              </tr>
            ))}
            {dashboardData.recentBookings.length === 0 && (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: '#a0aec0', padding: 24 }}>
                  No bookings found for {periodLabel}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* DRILL-DOWN MODAL */}
      {modal.isOpen && (
        <div className="prm-overlay" onClick={closeModal}>
          <div className="prm-form-modal" style={{ maxWidth: 900, maxHeight: '85vh' }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="list" size={22} /></span>
                <div>
                  <h3>{modal.title}</h3>
                  <p>{periodLabel} · {modal.total || modal.data.length} records</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeModal}>×</button>
            </div>

            <div className="prm-form-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
              {modal.data.length > 0 ? (
                <div className="prm-table-wrap">
                  <table className="prm-table">
                    <thead>
                      <tr>{modal.columns.map((c, i) => <th key={i}>{c}</th>)}</tr>
                    </thead>
                    <tbody>
                      {modal.data.map((item, i) => (
                        <tr key={item._id || item.id || i}>
                          {modal.columns.map((col, ci) => renderCell(item, col, ci))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="prm-empty" style={{ margin: 0 }}>
                  <div className="icon"><Icon name="info" size={44} /></div>
                  <h3>No data available</h3>
                  <p>No records found for {periodLabel}.</p>
                </div>
              )}
            </div>

            <div className="prm-form-foot">
              <span className="prm-foot-hint">Total records: {modal.total || modal.data.length}</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={closeModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;